module.exports = __webpack_public_path__ + "static/media/lousa-5.2a6ae74b.jpg";